export default __webpack_public_path__ + "static/media/26.63f09cb7.jpg";